import React from 'react'

import { Modal as ModalContainer, Box } from '@mui/material'

interface ModalProps {
  children: any
  height?: string
  width?: string
  overflow?: string
  position?: string
  border?: string
  openModal?: any
}

const Modal: React.FC<ModalProps> = ({
  children,
  height,
  width,
  overflow,
  border,
  openModal
}) => {
  const style = {
    bgcolor: 'background.paper',
    border: 'none' || border,
    height: height || '90%',
    left: '50%',
    overflow: overflow || 'auto',
    p: 2,
    position: 'absolute' as const,
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: width || '90%'
  }

  return (
    <>
      <ModalContainer
        open={openModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>{children}</Box>
      </ModalContainer>
    </>
  )
}

export default Modal
